module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-HairlineItalic-8e3c58fa559a1df17f059973a546fc0f.woff2";